import { render, staticRenderFns } from "./FullScreenFileThumbnail.vue?vue&type=template&id=0b55e69a&scoped=true&"
import script from "./FullScreenFileThumbnail.vue?vue&type=script&lang=ts&"
export * from "./FullScreenFileThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./FullScreenFileThumbnail.vue?vue&type=style&index=0&id=0b55e69a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b55e69a",
  null
  
)

export default component.exports